import { render, staticRenderFns } from "./Website-Info.vue?vue&type=template&id=3ca6bcc6&"
import script from "./Website-Info.vue?vue&type=script&lang=js&"
export * from "./Website-Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports